export default {
    methods: {
        async sendRequest(
            request,
            {
                beforeSendText,
                successText,
                errorText,

                failureCondition,

                successOptions,

                onSuccess,
                onError
            }
        ) {
            if (!failureCondition) {
                failureCondition = response => {
                    return response.status != "success";
                };
            }

            if (!successOptions) successOptions = {};

            this.$swal({
                title: `${beforeSendText}...`,
                text: this.$config("WAIT"),
                showConfirmButton: false,
                allowOutsideClick: false
            });

            try {
                // request is a promise
                let r = await request;

                if (failureCondition(r)) {
                    this.$swal({
                        text: errorText || r.message,
                        icon: "warning",
                        confirmButtonText: "OK"
                    });

                    if (onError) onError();

                    return;
                }

                onSuccess(r);

                this.$swal({
                    title: successText,
                    icon: "success",
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    timer: 2000,
                    ...successOptions
                });
            } catch (err) {
                console.log(err);
                this.$swal({
                    text: this.$config("C_PROBLEM"),
                    icon: "warning",
                    confirmButtonText: "OK"
                });
            }
        }
    }
};
